import { CircularProgress, Theme, useMediaQuery } from '@mui/material';
import { EmptyCon } from 'components/atoms';
import { Modal } from 'components/molecules/Modal/Modal';
import { CenterModalContentStyle, CenterModalStyle } from 'components/molecules/Modal/style';
import { checkoutWithWallet } from 'network/services/checkout';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import { useSetRecoilState } from 'recoil';
import modalAtom from 'store/atoms/modals';
import { PaymentModalCon } from './style';

type PaymentModalProp = {
  onSucces?: () => void;
  amount: number;
};

export const PayWithMadinaModal = ({ amount, onSucces }: PaymentModalProp) => {
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const setModalState = useSetRecoilState(modalAtom);
  const hasAttemptedPayment = useRef(false);

  const { mutateAsync, isLoading } = useMutation({ mutationFn: checkoutWithWallet });

  const setModalClose = () => {
    setModalState(c => ({ ...c, payWithMandinaModalOpen: false, paymentModalOpen: false }));
  };

  const withdrawFromWallet = useCallback(async () => {
    if (isLoading || hasAttemptedPayment.current) return;

    hasAttemptedPayment.current = true;
    try {
      await mutateAsync({ amount });
      onSucces && onSucces();
    } catch (error) {
      const errorMessage = (error as any)?.response?.data?.message || (error as any)?.response?.data?.description || 'Payment failed. Please try again.';
      const errorStatus = (error as any)?.response?.data?.status;

      if (errorStatus === 'success') {
        onSucces && onSucces();
      } else if (errorStatus === 'failed') {
        enqueueSnackbar(errorMessage, { variant: 'error' });
        setModalState(c => ({
          ...c,
          paymentFailureModalOpen: true,
          paymentModalOpen: false,
          payWithMandinaModalOpen: false
        }));
      } else {
        // Handle any other errors
        enqueueSnackbar(errorMessage, { variant: 'error' });
        setModalState(c => ({
          ...c,
          paymentFailureModalOpen: true,
          paymentModalOpen: false,
          payWithMandinaModalOpen: false
        }));
      }
    }
  }, [amount, mutateAsync, onSucces, isLoading, setModalState]);

  // Call withdrawFromWallet immediately when component mounts
  useEffect(() => {
    withdrawFromWallet();
  }, []); // Empty dependency array

  return (
    <Modal
      onModalClose={setModalClose}
      extraModalContentStyle={{ ...CenterModalContentStyle, width: sm ? '500px' : '' }}
      extraModalStyle={CenterModalStyle}>
      <PaymentModalCon>
        {isLoading && (
          <EmptyCon>
            <CircularProgress size={30} />
          </EmptyCon>
        )}
      </PaymentModalCon>
    </Modal>
  );
};
